module.exports = __webpack_public_path__ + "static/img/logo120.67f695c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo120.png
// module id = ymYg
// module chunks = 1